import React, { useState } from 'react'
import { ClipLoader } from 'react-spinners'

export function Form(props){
  const [ confirmDelete, setConfirmDelete ] = useState(false)
  const { showCancel=true, title, show, isSubmitting, validationMessage, rightTitleLabel, submitButtonLabel='Submit', deleteButtonLabel='Delete', errors=[], isDeleting } = props
  const { handleValidateRequiredFields, handleErrors=(k)=>(k), handleSubmit, handleClose, handleDelete } = props

  const Container = (props) => {
    return isModal ?
      <Modal show={show} title={title} handleClose={handleClose} rightTitleLabel={rightTitleLabel}>{props.children}</Modal> :
      <div>{props.children}</div>
  } 

  function isSubmitButtonDisabled(){
    return(!handleValidateRequiredFields || isSubmitting || isDeleting)
  }

  function handleClickDelete(){
    if (!confirmDelete){
      setConfirmDelete(true)
      setTimeout(()=>{setConfirmDelete(false)},3000)
    } else {
      handleDelete() 
      setConfirmDelete(false)
    }
  }

  return(
    <div>
      {props.children}
      {
        errors.length > 0 && 
        <div className="pt-1 pb-4">
          <div className="font-weight-bold">The Following Error(s) occurred:</div>
          <div className="pt-2 pl-3">
            {errors.map((error, index) => (
                <div key={index} className="text-danger d-flex mt-1">
                  <div><i className="fas fa-exclamation-triangle"/></div>
                  <div className="pl-2">{String(error)}</div>
                </div>
            ))}
          </div>
        </div>
      }
      <div className="d-flex d-flex flex-row-reverse justify-content-between align-items-center">
        <div>
          { !isSubmitting && showCancel && <div className="btn btn-outline-secondary" style={{cursor: 'pointer'}} onClick={handleClose}>Cancel</div> }
            { !handleValidateRequiredFields() ?
              <button disabled className="btn btn-danger ml-3">
                { handleErrors() ? 
                  'Error' : 
                  (validationMessage ? validationMessage : 'All Fields Are Required') }
              </button> :
              <button disabled={isSubmitButtonDisabled()} className="btn btn-primary ml-3" onClick={handleSubmit}>
                {
                  isSubmitting ? 
                  <ClipLoader color="#ffffff" size={14}/> :
                  submitButtonLabel
                }
              </button>
            }
        </div>
        <div>
          { handleDelete && 
            (
              confirmDelete ? 
              <button disabled={isSubmitButtonDisabled()} onClick={handleClickDelete} className="btn btn-danger">
                { isDeleting ? <ClipLoader color="#ffffff" size={14}/> : (
                  confirmDelete ? 'Confirm?' : deleteButtonLabel
                )}
              </button>:
              <button disabled={isSubmitButtonDisabled()} onClick={handleClickDelete} className="btn btn-warning">
                {deleteButtonLabel}
              </button>
            )
          } 
        </div>
      </div>
    </div>
  )
}

export default Form